/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Integration platform type
 * @export
 */
export const ControlPlatform1 = {
    Aws: 'aws',
    Axonius: 'axonius',
    Bitwarden: 'bitwarden',
    Box: 'box',
    CheckpointFirewall: 'checkpoint-firewall',
    CheckpointHarmony: 'checkpoint-harmony',
    CiscoCatalyst: 'cisco-catalyst',
    CiscoDuo: 'cisco-duo',
    CiscoMeraki: 'cisco-meraki',
    CiscoSecureAccess: 'cisco-secure-access',
    CiscoUmbrella: 'cisco-umbrella',
    ConnectwisePsa: 'connectwise-psa',
    CrowdstrikeFalcon: 'crowdstrike-falcon',
    Darktrace: 'darktrace',
    Email: 'email',
    Fortianalyzer: 'fortianalyzer',
    Fortinet: 'fortinet',
    GenericJson: 'generic-json',
    GenericSyslog: 'generic-syslog',
    GoogleAlertCenter: 'google-alert-center',
    GoogleDirectory: 'google-directory',
    GoogleSecurityCenter: 'google-security-center',
    Halcyon: 'halcyon',
    HaloItsm: 'halo-itsm',
    HaveIBeenPwned: 'have-i-been-pwned',
    Horizon3: 'horizon3',
    HyasProtect: 'hyas-protect',
    Ipinfo: 'ipinfo',
    JamfPro: 'jamf-pro',
    JamfProtect: 'jamf-protect',
    JiraCloud: 'jira-cloud',
    JiraDataCenter: 'jira-data-center',
    Jumpcloud: 'jumpcloud',
    Kandji: 'kandji',
    ManageEngineAdAuditPlus: 'manage-engine-ad-audit-plus',
    Microsoft: 'microsoft',
    MicrosoftEntra: 'microsoft-entra',
    MicrosoftTeams: 'microsoft-teams',
    MicrosoftTeamsV2: 'microsoft-teams-v2',
    Mimecast: 'mimecast',
    OdooHelpdesk: 'odoo-helpdesk',
    Okta: 'okta',
    OnePassword: 'one-password',
    OrcaSecurity: 'orca-security',
    PaloAltoNetworksCortex: 'palo-alto-networks-cortex',
    Picus: 'picus',
    PingOne: 'ping-one',
    ReversingLabs: 'reversing-labs',
    Safebreach: 'safebreach',
    SentinelOne: 'sentinel-one',
    ServiceNow: 'service-now',
    Slack: 'slack',
    Sms: 'sms',
    Smtp: 'smtp',
    SonicWall: 'sonic-wall',
    Stairwell: 'stairwell',
    ThinkstCanary: 'thinkst-canary',
    Vectra: 'vectra',
    WatchguardFirebox: 'watchguard-firebox',
    WindowsEventLogs: 'windows-event-logs',
    Wirespeed: 'wirespeed',
    Wiz: 'wiz',
    Wordfence: 'wordfence',
    ZscalerZpa: 'zscaler-zpa'
} as const;
export type ControlPlatform1 = typeof ControlPlatform1[keyof typeof ControlPlatform1];


export function ControlPlatform1FromJSON(json: any): ControlPlatform1 {
    return ControlPlatform1FromJSONTyped(json, false);
}

export function ControlPlatform1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPlatform1 {
    return json as ControlPlatform1;
}

export function ControlPlatform1ToJSON(value?: ControlPlatform1 | null): any {
    return value as any;
}

